// extracted by mini-css-extract-plugin
export var bg = "scrollprogress-module--bg--76d4f";
export var circle = "scrollprogress-module--circle--f1c2d";
export var container = "scrollprogress-module--container--ab5b3";
export var indicator = "scrollprogress-module--indicator--e3ce1";
export var phone = "scrollprogress-module--phone--7b786";
export var progress = "scrollprogress-module--progress--ea8c7";
export var wrapper = "scrollprogress-module--wrapper--1db11";